import { AgentSettings, AGENT_SETTINGS_METADATA, AgentSettingMetadata } from './../../interfaces/agent-settings';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-agent-settings-list',
  templateUrl: './agent-settings-list.component.html',
})
export class AgentSettingsListComponent {
  agentSettingsList: { label: string; tooltip: string; value: string }[] = [];

  private _agentSettings?: AgentSettings | null = null ;

  @Input()
  set agentSettings(value: AgentSettings | null ) {
    this._agentSettings = value;

    if (value) {
      this.setAgentSettingsList(value);
    } else {
      this.agentSettingsList = [];
    }
  }

  get agentSettings(): AgentSettings | null  {
    return this._agentSettings ?? null;
  }

  private setAgentSettingsList(settings: AgentSettings): void {
    this.agentSettingsList = (Object.keys(AGENT_SETTINGS_METADATA) as (keyof AgentSettings)[])
      .map((key) => {
        const metadata: AgentSettingMetadata | undefined = AGENT_SETTINGS_METADATA[key];
        if (!metadata) return null;
  
        const rawValue: number | boolean = settings[key];
        const displayValue: string =
          typeof rawValue === 'number' && metadata.unit
            ? `${rawValue} ${metadata.unit}`
            : `${rawValue}`;
  
        return {
          label: metadata.label,
          tooltip: metadata.tooltip,
          value: displayValue,
        };
      })
      .filter((item): item is { label: string; tooltip: string; value: string } => item !== null);
  }
  

}
